export default class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach((button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M-2.62268e-07 6C-2.80374e-07 5.58579 0.335786 5.25 0.75 5.25L11.3879 5.25L7.23017 1.29062C6.93159 1.00353 6.92228 0.528746 7.20937 0.230167C7.49647 -0.0684112 7.97125 -0.077721 8.26983 0.209374L13.7698 5.45937C13.9169 5.60078 14 5.79599 14 6C14 6.20401 13.9169 6.39922 13.7698 6.54062L8.26983 11.7906C7.97125 12.0777 7.49647 12.0684 7.20938 11.7698C6.92228 11.4713 6.93159 10.9965 7.23017 10.7094L11.3879 6.75L0.75 6.75C0.335786 6.75 -2.44163e-07 6.41421 -2.62268e-07 6Z" fill="#360A06"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-download')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-gallery')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-lang')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-replay')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 12.5143V0.851193C0.75 0.775288 0.831248 0.727056 0.897885 0.763404L11.5891 6.59495C11.6585 6.63285 11.6585 6.73263 11.5891 6.77053L0.897885 12.6021C0.831248 12.6384 0.75 12.5902 0.75 12.5143Z" stroke="#360A06" stroke-width="1.5"/>
</svg>
`;
				element.classList.add('svg');
				button.appendChild(element);
			}
		});
	}
}
